// App.js
import React, { useMemo, useState } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { ThemeProvider, CssBaseline } from '@mui/material';
import { lightTheme, darkTheme } from './themes';

import Header from './components/Header';
import Drinks from './components/Drinks';
import DrinkDetails from './components/DrinkDetails';
import IngredientAssistant from './components/IngredientAssistant';
import Episodes from './components/Episodes';
import EpisodeDetails from './components/EpisodeDetails';
import HomePage from './components/HomePage';
import LoginPage from './components/LoginPage';

function App() {
  const [mode, setMode] = useState('dark'); // or check system preference

  const theme = useMemo(() => (mode === 'dark' ? darkTheme : lightTheme), [mode]);

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <Router>
        <Header toggleMode={() => setMode(mode === 'dark' ? 'light' : 'dark')} mode={mode} />
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/drinks" element={<Drinks />} />
          <Route path="/drinks/:id" element={<DrinkDetails />} />
          <Route path="/episodes" element={<Episodes />} />
          <Route path="/episodes/:id" element={<EpisodeDetails />} />
          <Route path="/ingredient-assistant" element={<IngredientAssistant />} />
          <Route path="/login" element={<LoginPage />} />
        </Routes>
      </Router>
    </ThemeProvider>
  );
}

export default App;
